export const dataTransferFiles = event => {
    let dataTransferItemsList = [];

    if (event.dataTransfer) {
        const dt = event.dataTransfer;
        if (dt.files && dt.files.length) {
            dataTransferItemsList = dt.files;
        }
    } else if (event.target && event.target.files) {
        dataTransferItemsList = event.target.files;
    }

    return Array.prototype.slice.call(dataTransferItemsList);
}
